import { render } from "./ViewAssign.vue?vue&type=template&id=7378d3c4&ts=true"
import script from "./ViewAssign.vue?vue&type=script&lang=ts"
export * from "./ViewAssign.vue?vue&type=script&lang=ts"

import "./ViewAssign.vue?vue&type=style&index=0&id=7378d3c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__